import { Component, LOCALE_ID, OnInit } from '@angular/core';
import { CommonModule, registerLocaleData } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { NxExpertModule } from '@aposin/ng-aquila/config';
import localeEs from '@angular/common/locales/es';
import localeFr from '@angular/common/locales/fr';
import localeEn from '@angular/common/locales/en';
import localeIt from '@angular/common/locales/it';
import localeDe from '@angular/common/locales/de';
import { HttpClientModule } from '@angular/common/http';
import { NxDialogService } from '@aposin/ng-aquila/modal';
import { AuthService } from './core/services/nx-auth/auth.service';
import { AdobeAnalyticsService } from './core/services/nx-adobe-analytics/adobe-analytics.service';
import { environment } from '../environments/environment';

registerLocaleData(localeEs);
registerLocaleData(localeDe);
registerLocaleData(localeFr);
registerLocaleData(localeEn);
registerLocaleData(localeIt);

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterOutlet, NxExpertModule, HttpClientModule, TranslateModule],
  providers: [NxDialogService, TranslateService, { provide: LOCALE_ID, useValue: 'fr-FR' }],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'Selfcare-ndbx';
  locale = (navigator && navigator.language.split('-')[0]) || 'fr';
  //  lang = this._authService.getLocalStorageLanguage();
  lang = 'fr';

  constructor(
    public translate: TranslateService,
    private _authService: AuthService,
    private _adobeAnalyticsService: AdobeAnalyticsService
  ) {
    this.translate.addLangs(['fr', 'en', 'es', 'it', 'de']);
    this.translate.setDefaultLang('fr'); // Set default language to French

    const browserLang = this.translate.getBrowserLang();
    const langs = browserLang!.match(/fr|en|es|it|de/) ? browserLang : 'fr';
    this.translate.use(this.lang);
  }

  ngOnInit(): void {
    // Cargar Adobe Analytics
    this._adobeAnalyticsService.loadScript(environment.adobeUrl);
  }
}
